import {Box} from "@mui/system";
import SuppliersTable from "../table/orders/organization/suppliers/SuppliersTable";
import TextFieldValidation from "../table/customer-detales/TextFieldValidation";
import {Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, Step, StepLabel, Stepper} from "@mui/material";
import {replaceEmptyStringsOnNull} from "../../../utils/ReplaceEmptyStringsOnNull";
import {useEffect, useState} from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import MenuItem from "@mui/material/MenuItem";
import ButtonCreate from "../button/ButtonCreate";
import ButtonAdd from "../button/ButtonAdd";
import ButtonExit from "../button/ButtonExit";
import ButtonBack from "../button/ButtonBack";
import {materialPriceUnitField} from "../../../data/MaterialPriceUnitField";

export const ExportingSupplyRequestsModal = ({
                                                 open,
                                                 title,
                                                 initValue,
                                                 onClose,
                                                 onSubmit,
                                                 suppliers,
                                                 handleModalAlert,
                                                 nameSheet,
                                                 loading
                                             }) => {
    const allMaterialPriceUnitField = Object.entries(materialPriceUnitField)

    const emptyValue = {
        "columnName": allMaterialPriceUnitField[0][1],
        "field": allMaterialPriceUnitField[0][0],
        "columnWidth": 0,
        "headerFontName": "",
        "headerFontBold": false,
        "headerFontItalic": false,
        "headerFontSize": 0,
        "valuesFontName": "",
        "valuesFontBold": false,
        "valuesFontItalic": false,
        "valuesFontSize": 0
    }

    const [validationState, setValidationState] = useState({columnName: ""})
    const [value, setValue] = useState({nameSheet: ""})
    const [columns, setColumns] = useState([emptyValue])
    const [currColumn, setCurrColumn] = useState(0)
    const [activeStep, setActiveStep] = useState(0)
    const [selectedString, setSelectedString] = useState({})
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 20,
        totalElements: suppliers?.length,
        searchData: ""
    })

    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
    }
    useEffect(() => {
        if (nameSheet) {
            setColumns(initValue)
        }
    }, [open])

    const addColumns = (old) => {
        const newErrors = {...validationState}

        Object.entries(columns[currColumn]).forEach(([name, value]) => {
            if (name === "columnName" && value === "") {
                newErrors[name] = "пустое поле"
            }
        })
        setValidationState(newErrors)
        if (Object.values(newErrors).every(el => el === "")) {
            if (old !== undefined) {
                setCurrColumn(old)
            } else {
                setColumns(prev => [...prev, emptyValue])
                setCurrColumn(columns.length)
            }
        }
    }

    const handleDelete = (i) => {
        setColumns(prev => prev.filter((el, index) => index !== i))
        if (currColumn > i || currColumn === columns.length - 1) {
            setCurrColumn(prev => prev - 1)
        }
    }

    const editField = (updater, i) => {
        const value = updater().field
        setColumns(prev => prev.map((el, index) => index === i ? {
            ...el,
            field: value,
            columnName: materialPriceUnitField[value]
        } : el))
    }
    const editFormState = (updater, field, i) => {
        if (updater) {
            const value = updater()[field]
            setColumns(prev => prev.map((el, index) => index === i ? {...el, [field]: value} : el))
        } else {
            setColumns(prev => prev.map((el, index) => index === i ? {...el, [field]: !el[field]} : el))
        }
    }

    const handleClose = () => {
        setActiveStep(0)
        setCurrColumn(0)
        setSelectedString({})
        setValue({nameSheet: ""})
        setColumns([emptyValue])
        onClose()
    }
    const back = () => {
        setActiveStep(prev => prev - 1)
    }
    const handleValidationData = () => {
        if (activeStep === 0 && !nameSheet) {
            setActiveStep(1)
        } else if (activeStep === 1 && !nameSheet) {
            setActiveStep(2)
        } else {
            const newErrors = {...validationState}

            Object.entries(columns[currColumn]).forEach(([name, value]) => {
                if (name === "columnName" && value === "") {
                    newErrors[name] = "пустое поле"
                }
            })
            setValidationState(newErrors)

            if (Object.values(newErrors).every(el => el === "")) {
                const res = columns.map(el => replaceEmptyStringsOnNull(el))
                const data = nameSheet ? {"columns": res} : {nameSheet: value?.nameSheet, "columns": res}
                onSubmit(data, selectedString?.id)
                handleClose()
            }
        }
    }

    return <Dialog open={open}>
        <Box style={{
            padding: "16px 24px",
            display: "flex",
            flexDirection: "column",
            gap: 16,
            alignItems: "center"
        }}>
            <DialogTitle sx={{
                color: (theme) => theme.palette.text.main,
                margin: "auto",
                padding: 0,
                fontSize: 24,
                fontWeight: 700
            }}>{title}</DialogTitle>
            {!nameSheet && <Stepper
                alternativeLabel
                style={{width: "600px"}}
                activeStep={activeStep}>
                {["Поставщики", "Наименование", "Колонки"].map((label) => (
                    <Step key={label} sx={{
                        "& .MuiStepConnector-root": {
                            top: "20px",
                            left: 'calc(-50% + 30px)',
                            right: "calc(50% + 30px)"
                        }
                    }}>
                        <StepLabel sx={{
                            ".MuiSvgIcon-root": {
                                fontSize: 40,
                                color: "#737478",
                                "&.Mui-active": {
                                    color: "#3B8BEC",
                                }
                            },
                            "& .MuiStepLabel-label": {
                                fontSize: 18,
                                "&.Mui-active": {
                                    fontWeight: 700,
                                }
                            },

                        }}>{label}</StepLabel>
                    </Step>
                ))}
            </Stepper>}
        </Box>
        <DialogContent>
            {(activeStep === 0 && !nameSheet) ?
                <Box style={{display: "flex", flexDirection: "column"}}>
                    <Box style={{width: "100%"}}>
                        <SuppliersTable
                            data={suppliers} isModal={true} selectedString={selectedString}
                            setSelectedString={setSelectedString}
                            tableOptions={tableOptions}
                            tableOptionsHandle={tableOptionsHandle}
                            handleModalAlert={handleModalAlert}/>
                    </Box>
                </Box>
                : (activeStep === 1 && !nameSheet) ?
                    <Box sx={{minWidth: "400px"}}>
                        <TextFieldValidation
                            name={"nameSheet"}
                            value={value?.nameSheet}
                            label="Наименование"
                            setCurrValues={setValue}
                        />

                    </Box> : <Box sx={{
                        minWidth: "400px",
                        gap: "10px",
                        display: 'flex',
                        flexDirection: "column",
                        alignItems: "flex-end"
                    }}>
                        {columns.map((el, i) => currColumn === i ?
                            <Box sx={{
                                display: "flex", width: "100%",
                                alignItems: "center"
                            }}>
                                <Box sx={{
                                    border: "1px solid #3B8BEC",
                                    padding: "10px 10px 0 10px",
                                    borderRadius: "10px"
                                }}>
                                    <TextFieldValidation
                                        select
                                        name="field"
                                        label="Колонка таблицы"
                                        value={el.field}
                                        setCurrValues={(updater) => editField(updater, i)}
                                        margin={"none"}
                                    >
                                        {allMaterialPriceUnitField?.map((option) => (
                                            <MenuItem key={option[0]} value={option[0]}>
                                                {option[1]}
                                            </MenuItem>
                                        ))}
                                    </TextFieldValidation>
                                    <TextFieldValidation
                                        name={"columnName"}
                                        value={el?.columnName}
                                        setCurrValues={(updater) => editFormState(updater, "columnName", i)}
                                        label="Наименование колонки"
                                        validationError={validationState?.columnName}
                                        setValidationState={setValidationState}
                                    />

                                    <TextFieldValidation
                                        name={"columnWidth"}
                                        value={el?.columnWidth}
                                        label="Ширина колонки"
                                        setCurrValues={(updater) => editFormState(updater, "columnWidth", i)}
                                        type={"number"}
                                    />
                                    <TextFieldValidation
                                        name={"headerFontName"}
                                        value={el?.headerFontName}
                                        label="Шрифт заголовка"
                                        setCurrValues={(updater) => editFormState(updater, "headerFontName", i)}
                                    />

                                    <TextFieldValidation
                                        name={"headerFontSize"}
                                        value={el?.headerFontSize}
                                        label="Размер шрифта заголовока"
                                        setCurrValues={(updater) => editFormState(updater, "headerFontSize", i)}
                                        type={"number"}
                                    />
                                    <TextFieldValidation
                                        name={"valuesFontName"}
                                        value={el?.valuesFontName}
                                        label="Шрифт"
                                        setCurrValues={(updater) => editFormState(updater, "valuesFontName", i)}
                                    />
                                    <TextFieldValidation
                                        name={"valuesFontSize"}
                                        value={el?.valuesFontSize}
                                        label="Размер шрифта"
                                        setCurrValues={(updater) => editFormState(updater, "valuesFontSize", i)}
                                        type={"number"}
                                    />
                                    <FormControlLabel control={<Checkbox
                                        checked={el.headerFontBold}
                                        onChange={() => editFormState(null, "headerFontBold", i)}
                                    />} label="Жирный заголовок"/>
                                    <FormControlLabel control={<Checkbox
                                        checked={el.headerFontItalic}
                                        onChange={() => editFormState(null, "headerFontItalic", i)}
                                    />} label="Курсивный заголовок"/>
                                    <FormControlLabel control={<Checkbox
                                        checked={el.valuesFontBold}
                                        onChange={() => editFormState(null, "valuesFontBold", i)}
                                    />} label="Жирный текст"/>
                                    <FormControlLabel control={<Checkbox
                                        checked={el.valuesFontItalic}
                                        onChange={() => editFormState(null, "valuesFontItalic", i)}
                                    />} label="Курсивный текст"/>
                                </Box>
                                {columns.length !== 1 &&
                                    <DeleteOutlineOutlinedIcon onClick={() => handleDelete(i)}/>}
                            </Box> : <Box sx={{
                                display: "flex", width: "100%",
                                alignItems: "center"
                            }}>
                                <Box
                                    onClick={() => addColumns(i)}
                                    sx={{
                                        border: "1px solid #3B8BEC",
                                        padding: "10px",
                                        borderRadius: "10px",
                                        width: "96%"
                                    }}>
                                    <TextFieldValidation
                                        select
                                        name="field"
                                        label="Колонка таблицы"
                                        value={el.field}
                                        setCurrValues={editField}
                                        disabled={true}
                                    >
                                        {allMaterialPriceUnitField?.map((option) => (
                                            <MenuItem key={option[0]} value={option[0]}>
                                                {option[1]}
                                            </MenuItem>
                                        ))}
                                    </TextFieldValidation>
                                </Box>
                                <DeleteOutlineOutlinedIcon onClick={() => handleDelete(i)}/>
                            </Box>)}

                        <Box sx={{marginRight: columns.length !== 1 && "25px"}}>
                            <ButtonCreate
                                text={"Добавить ещё колонку"}
                                width={300}
                                onClick={() => addColumns()}
                            />
                        </Box>
                    </Box>}
        </DialogContent>
        <DialogActions sx={{
            padding: "40px",
            display: "flex",
            justifyContent: activeStep !== 0 ? "space-between" : "flex-end"
        }}>
            {activeStep !== 0 && <ButtonBack text={"Назад"} onClick={back}/>}
            <Box>
                <ButtonExit text={"Отменить"} onClick={handleClose}/>
                <ButtonAdd
                    loading={loading}
                    text={"Выбрать"} onClick={handleValidationData}
                           disabled={(activeStep === 0 && !nameSheet && !selectedString?.id) || (activeStep === 1 && !nameSheet && !value.nameSheet)}/>
            </Box>
        </DialogActions>
    </Dialog>
}